<template>
	<section v-if="articles.length > 0" class="guide-list" :class="{ inline }">
		<h3 class="heading guide-list__heading"><slot></slot></h3>

		<HiddenHorizontalScrollbar v-if="inline">
			<ul>
				<li v-for="(article, index) in articles" :key="article.content.fullPath">
					<GuideItem
						:item="article"
						:clamp="4"
						:showParagraph="false"
						:isBadgeInline="!isTitle"
						:index="index"
						:h4Heading="h4Heading"
					/>
				</li>
			</ul>
		</HiddenHorizontalScrollbar>

		<ul v-else>
			<li v-for="(article, index) in articles" :key="article.content.fullPath">
				<GuideItem :item="article" :clamp="4" :showParagraph="false" :index="index" :h4Heading="h4Heading" />
			</li>
		</ul>
	</section>
</template>

<script setup lang="ts">
import GuideItem from '@/features/editorial/components/GuideItem.vue';
import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';

import { useArticleList } from '@/features/editorial/composables/useArticleList';
import { BackdropProfile, ImageFormat } from '@/@types/graphql-types';

interface GuideListProps {
	listSize?: number;
	inline?: boolean;
	entityId?: string;
	h4Heading?: boolean;
	isTitle?: boolean;
	relatedArticleId?: number;
}

const props = withDefaults(defineProps<GuideListProps>(), {
	listSize: 15,
});

const { articles } = useArticleList({
	pageSize: props.listSize,
	entityId: props.entityId,
	isTitle: props.isTitle,
	profile: BackdropProfile.S480,
	format: ImageFormat.Jpg,
	relatedArticleId: () => props.relatedArticleId,
});
</script>

<style lang="scss" scoped>
@import '~@/styles/sports.scss';

.guide-list {
	.heading {
		margin: 0;
		margin-bottom: 16px;
		font-weight: 700;
		text-transform: uppercase;
		font-size: 16px;
		color: $color-text-dark;
	}

	ul {
		margin: 0;
		padding: 0;
		list-style: none;
		display: flex;
		flex-direction: column;
		gap: 32px;
	}

	&.inline {
		ul {
			height: auto;
			flex-direction: row;
			gap: 16px;

			li {
				min-width: 320px;
				width: 320px;
			}
		}
	}
}
</style>
